import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Diagnostic from "@/pages/Diagnostic";
import Results from "@/pages/Results";
import Compare from "@/pages/Compare";
import Admin from "@/pages/Admin";
import AdminMockups from "@/pages/AdminMockups";
import ConsultingPreTest from "@/pages/ConsultingPreTest";
import ConsultingTest from "@/pages/ConsultingTest";
import ConsultingWaiting from "@/pages/ConsultingWaiting";
import ConsultingActivate from "@/pages/ConsultingActivate";
import ConsultingSharedReport from "@/pages/ConsultingSharedReport";
import ConsultingSharedRun from "@/pages/ConsultingSharedRun";
import ConsultingSharedChecklist from "@/pages/ConsultingSharedChecklist";
import ConsultingReport from "@/pages/ConsultingReport";
import ConsultingChecklist from "@/pages/ConsultingChecklist";
import ConsultingCompare from "@/pages/ConsultingCompare";
import ConsultingTools from "@/pages/ConsultingTools";
import ConsultingToolPage from "@/pages/ConsultingToolPage";
import ConsultingPerception from "@/pages/ConsultingPerception";
import PerceptionPublicTest from "@/pages/PerceptionPublicTest";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import ConsultingTablero from "@/pages/ConsultingTablero";
import CadenaReviewTmp from "@/pages/CadenaReviewTmp";
import { getToken } from "@/lib/api";

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/" replace />;
}

// La lista de consultorías vive ahora en el dashboard (banner «Tus consultorías»).
function ConsultingToDashboard() {
  localStorage.setItem("dash_expand_consulting", "1");
  return <Navigate to={`/dashboard${window.location.search}#consultorias`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/diagnostic"
          element={
            <RequireAuth>
              <Diagnostic />
            </RequireAuth>
          }
        />
        <Route
          path="/results/:id"
          element={
            <RequireAuth>
              <Results />
            </RequireAuth>
          }
        />
        <Route
          path="/compare"
          element={
            <RequireAuth>
              <Compare />
            </RequireAuth>
          }
        />
        <Route
          path="/compare/:a/:b"
          element={
            <RequireAuth>
              <Compare />
            </RequireAuth>
          }
        />
        <Route
          path="/compare/:a/:b/:c"
          element={
            <RequireAuth>
              <Compare />
            </RequireAuth>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Admin />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/cadena-revision"
          element={
            <RequireAuth>
              <CadenaReviewTmp />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/mockups"
          element={
            <RequireAuth>
              <AdminMockups />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting"
          element={
            <RequireAuth>
              <ConsultingToDashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/new"
          element={
            <RequireAuth>
              <ConsultingPreTest />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/test/:testId"
          element={
            <RequireAuth>
              <ConsultingTest />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/:testId"
          element={
            <RequireAuth>
              <ConsultingWaiting />
            </RequireAuth>
          }
        />
        <Route path="/consulting/activate/:token" element={<ConsultingActivate />} />
        <Route path="/consulting/shared/:token" element={<ConsultingSharedReport />} />
        <Route path="/consulting/shared/run/:token" element={<ConsultingSharedRun />} />
        <Route path="/consulting/shared/:token/checklist" element={<ConsultingSharedChecklist />} />
        <Route path="/perception/:token" element={<PerceptionPublicTest />} />
        <Route
          path="/consulting/:testId/report"
          element={
            <RequireAuth>
              <ConsultingReport />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/:testId/checklist"
          element={
            <RequireAuth>
              <ConsultingChecklist />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/compare"
          element={
            <RequireAuth>
              <ConsultingCompare />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/:testId/tools"
          element={
            <RequireAuth>
              <ConsultingTools />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/:testId/tools/:toolKey"
          element={
            <RequireAuth>
              <ConsultingToolPage />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/:testId/perception"
          element={
            <RequireAuth>
              <ConsultingPerception />
            </RequireAuth>
          }
        />
        <Route
          path="/consulting/:testId/tablero"
          element={
            <RequireAuth>
              <ConsultingTablero />
            </RequireAuth>
          }
        />
        <Route
          path="/cuenta"
          element={
            <RequireAuth>
              <Account />
            </RequireAuth>
          }
        />
        <Route path="/legal/:slug" element={<LegalPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
